export default __webpack_public_path__ + "static/media/formNavArrow.ea6c411b.svg";